import { render } from "./App.vue?vue&type=template&id=08d9ef47&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=08d9ef47&lang=scss&scoped=true"

import exportComponent from "E:\\developYZ\\yzWebsite\\newWebsite\\my-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d9ef47"]])

export default __exports__